import { FiltersInterface } from "../../../../Global/Interfaces/GlobalInterfaces";

export default class ListContentFilters implements FiltersInterface {
  public limit?: number = null;
  public page?: number = null;

  constructor(filters: any) {
    this.limit = filters && filters.limit ? filters.limit : null;
    this.page = filters && filters.page ? filters.page : null;
  }

  constructFiltersUrl? = () => {
    let url = "";

    if (this.limit) {
      url += `&limit=${this.limit}`;
    }

    if (this.page) {
      url += `&page=${this.page}`;
    }

    return url;
  };
}
